'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = geocodingMiddleware;

var _types = require('shared/components/Page/types');

var _types2 = require('./types');

var _utils = require('./utils');

function geocodingMiddleware(_ref) {
  var dispatch = _ref.dispatch;

  return function (next) {
    return function (action) {
      var type = action.type,
          meta = action.meta,
          response = action.response;


      if (type === _types.FETCH_PAGE + '_FULFILLED') {
        var locations = (0, _utils.findLocations)(response);
        (0, _utils.geocodeLocations)(locations).then(function (geocodedLocations) {
          if (_utils.geocodeLocations.length) {
            dispatch({
              type: _types2.GEOCODE_LOCATIONS_FULFILLED,
              meta: meta,
              locations: geocodedLocations
            });
          }
        });
      } else if (type === _types2.GEOCODE_LOCATION) {
        (0, _utils.geocodeLocations)([{
          address: action.location
        }]).then(function (geocodedLocations) {
          if (_utils.geocodeLocations.length) {
            dispatch({
              type: _types2.GEOCODE_LOCATIONS_FULFILLED,
              meta: meta,
              locations: geocodedLocations
            });
          }
        });
      }

      next(action);
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/middlewares/geocoding/index.js
// module id = 1299
// module chunks = 0